import { Component, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
    selector: 'app-reg-inquiry',
    imports: [RouterModule],
    templateUrl: './reg-inquiry.component.html',
    styleUrls: ['./reg-inquiry.component.scss']
})
export class RegInquiryComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  
  }

}
